export const makeRequest = async (path: string, options: RequestInit) => {
  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/${path}`, {
      ...options,
      cache: "no-store",
    });

    return await response.json();
  } catch (e) {
    return { status: false };
  }
};
